<div attr.tid="{{config.label}}" *ngIf="!config.isHidden">
    <div class="tml-tpl-label" *ngIf="!config.isLabelHidden">
        <label>{{config.label}}<span *ngIf="config.isRequired" style="color:red;">&nbsp;*</span></label>
    </div>
    <div class="tml-tpl-input" [style.width.px]="config.width">
        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" #dropDownEl class="contact-dropdown"
            [data]="suggestionItems" [filterable]="true" (filterChange)="handleFilter($event)" [disabled]="readOnly"
            [textField]="'name'" [valueField]="'id'" [(ngModel)]="selectedItem" (focus)="dropDownEl.toggle(true)"
            (valueChange)="valueChange($event)" (keydown.esc)="onEnter($event)" (mousedown)="$event.preventDefault()">
            <ng-template kendoMultiSelectHeaderTemplate>
                <div class="popup-template-clear-header">
                    <span class="multiselect-Clear" (click)="clearValue()">Clear</span>
                </div>
            </ng-template>
            <div *ngIf="config.controlID === 'Company' || config.controlID.indexOf('Former_Employment_Company') !== -1">
                <ng-template kendoDropDownListItemTemplate let-dataItem>
                    <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
                </ng-template>
            </div>
            <div *ngIf="config.controlID.indexOf('Current_Employment_StartYear') == -1 &&
            config.controlID.indexOf('Former_Employment_StartYear') == -1 &&
            config.controlID.indexOf('Former_Employment_EndYear') === -1 &&
            config.controlID.indexOf('AddRelationshipType') === -1 &&
            config.controlID.indexOf('Former_Employment_JobTitle') === -1">
                <ng-template kendoDropDownListNoDataTemplate>
                    <div class="popup-template-no-data">
                        <div class="no-data"><span>NO DATA FOUND</span></div>
                        <div><span class="link" (click)="createEntity()">Create Entity</span></div>
                    </div>
                </ng-template>
            </div>
            <div *ngIf="config.controlID.indexOf('Former_Employment_JobTitle') !== -1">
                <ng-template kendoDropDownListNoDataTemplate>
                    <div class="popup-template-no-data">
                        <div class="no-data"><span>NO DATA FOUND</span></div>
                        <div><span class="link" (click)="createJobTitle()">Create Job Title</span></div>
                    </div>
                </ng-template>
            </div>
        </kendo-dropdownlist>
    </div>
    <label [hidden]="hasPermissionToView" class="dis-row">Company field contains a private entity that you have no
        permission to view</label>
    <label [hidden]="!showCompanyError" class="dis-row"> Entity <span>{{hintContent}}</span> not found, please<label
            class="hint-click" (click)="clickContactFly()"> create </label> or enter a new one
    </label>
    <label *ngIf="showEndYearError" class="dis-row">{{hintContent}}</label>
</div>